import { computed, ComputedRef } from 'vue';
import { storeToRefs } from 'pinia';
import { useChatbotConfigStore } from '@/config/stores/chatbotConfig';
import { findPermissionByTranslateId } from '@/common/permission/permission.utils';
import { ROLE_PERMISSION_KEY } from '@/common/define/rolePermission.define';

/**
 * AI 어시스턴트 진입점(App.vue 런처 · GNB 메뉴) 공통 노출 판정.
 *
 * 두 진입점이 각자 판정하면 한쪽만 바뀌었을 때 노출 정책이 조용히 어긋나므로 여기 한 곳에 둔다.
 * 두 조건 모두 `!== false` 인 이유:
 * - `settings.enabled`: 환경설정 fetch 실패 시 undefined → 기존처럼 노출 (UX 회귀 방지)
 * - `menuOnOff`: 권한 마이그레이션 전 환경에는 해당 키가 없어 undefined → 기존처럼 노출
 */
export const useAiAssistantVisible = (): ComputedRef<boolean> => {
  const { settings: chatbotSettings } = storeToRefs(useChatbotConfigStore());

  return computed(
    () =>
      chatbotSettings.value?.enabled !== false &&
      findPermissionByTranslateId(ROLE_PERMISSION_KEY.MONITORING.MONITORING_AI_ASSISTANT)
        ?.menuOnOff !== false,
  );
};
